'use client';

import {useTranslation} from 'react-i18next';
import {
  trackUnitTypesListingCardClick,
  trackUnitTypesListingRegisterInterestClick,
  trackUnitTypesListingViewItemClick,
} from '../../analytics';
import {UNIT_TYPES_EMPTY} from '../../content';
import {specChipLabel, type UnitTypeCardView} from '../../model';
import {unitHref} from '../../routing';
import {unitSpecIcon} from '../properties/unit-spec-icons';
import {EntityGridListing} from './EntityGridListing';

export interface UnitTypesGridCardListingProps {
  locale: string;
  items: UnitTypeCardView[];
  eyebrow?: string;
  projectId?: string;
  projectName?: string;
  phaseId?: string;
  phaseName?: string;
}

export function UnitTypesGridCardListing({
  locale,
  items,
  eyebrow,
  projectId,
  projectName,
  phaseId,
  phaseName,
}: UnitTypesGridCardListingProps) {
  const {t} = useTranslation();
  const analyticsExtra = {project_id: projectId, project_name: projectName, phase_id: phaseId, phase_name: phaseName};
  return (
    <EntityGridListing
      titleKey="unit_types"
      eyebrow={eyebrow}
      empty={UNIT_TYPES_EMPTY}
      items={items.map(unit => ({
        id: unit.uuid,
        registerInterest: {projectId, designTypeId: unit.uuid},
        title: unit.title,
        image: unit.image.src,
        href: unitHref(locale, unit.uuid),
        soldOut: unit.soldOut,
        statusAsTag: true,
        badges: unit.contextLabel ? [{label: unit.contextLabel}] : undefined,
        meta: unit.specs.map(spec => ({icon: unitSpecIcon(spec.key, 'sm'), label: specChipLabel(t, spec)})),
      }))}
      analytics={{
        onCardClick: item => {
          trackUnitTypesListingCardClick(item, analyticsExtra);
        },
        onViewItemClick: item => {
          trackUnitTypesListingViewItemClick(item, analyticsExtra);
        },
        onRegisterInterestClick: trackUnitTypesListingRegisterInterestClick,
      }}
    />
  );
}

UnitTypesGridCardListing.displayName = 'UnitTypesGridCardListing';
